import { PilotHistoryEntry } from '../types';
import { pilotHistoryActions } from './actions';

export interface PilotHistoryInitialState {
  pilotHistoryEntry: PilotHistoryEntry;
}

type actionType = {
  type: string;
  payload: { pilotHistoryEntry: PilotHistoryEntry };
};

const initialState: PilotHistoryInitialState = {
  pilotHistoryEntry: null,
};

export default function reducer(state = initialState, action: actionType) {
  switch (action.type) {
    case pilotHistoryActions.SET_PILOT_HISTORY_ENTRY: {
      return {
        ...state,
        pilotHistoryEntry: action.payload.pilotHistoryEntry,
      };
    }
    default: {
      return state;
    }
  }
}
